import styled from "styled-components";

export const StyledSystemCommandWrapper = styled.div`

`;

export const StyledAbstractCommandWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 25px;
  display: inline-flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.surface.faint};
  box-shadow: 0 2px 4px ${({theme}) => theme.surface.shadow};
  border-radius: 16px;
  transition: all .15s ease .15s;
  .command__description {
    padding-bottom: 20px;
    color: ${({theme}) => theme.text.primary};
    font-size: 18px;
    font-weight: 600;
  }
`;